import { Component, Inject, Input } from '@angular/core';

import { EntityCheckboxListComponent } from '../../shared/checkbox-list/components/entity-checkbox-list.component';

import { StaticTypeService } from '../services/static-types.service';
import { MemoCategory } from '../entities/memo-category.entity';

@Component({
	selector: 'memo-category-checkbox-list',
	templateUrl: '../../shared/checkbox-list/components/entity-checkbox-list.html',
	styleUrls: ['../../shared/checkbox-list/components/entity-checkbox-list.css']
})
export class MemoCategoryCheckboxListComponent extends EntityCheckboxListComponent<MemoCategory> {
	// Label du champ
	@Input() override label: string = "Catégorie";
	
	// Label de l'option neutre
	@Input() override wildcardOptionLabel = "Toutes"

	// Fonction determinant le label d'un parc
	override getEntityLabel = (maintenance: MemoCategory) => maintenance.label;

	constructor( //
		@Inject(StaticTypeService) private staticTypesService: StaticTypeService //
	) {
		super();
		this.staticTypesService.getMemoCategoryList().subscribe(
			(list: MemoCategory[]) => this.entities = list
		);
	}
}